
import { SetSnackBar } from '@/helpers/SnackbarHelper';
import { StringHelper } from '@/helpers/StringHelper';
import { InvoiceService } from '@/services/invoice-service';
import { Invoice } from '@/store/models/InvoiceModel';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
@Component
export default class InvoiceSearchBox extends Vue {
  /* Properties */
  @Prop() loadingTriggered!: boolean;
  /* Store Actions */
  /* Watchers */
  @Watch('searchText')
  onSearchTextChange(val: string) {
    val && val !== this.selectedSuggestion && this.getSuggestions();
  }
  /* Data */
  searchText: string = 'PartNumber';
  selectedSuggestion: any = null;
  suggestions: any[] = [];
  isLoading: boolean = false;
  typingTimer: any;
  doneTypingInterval: number = 250;
  /* Computed */
  /* Async Functions */
  async getInvoice() {
    if (!this.selectedSuggestion) return;
    this.$emit('invoiceSelected', this.selectedSuggestion.Id);
    this.$nextTick(() => {
      this.clearSearch();
    });
  }
  /* Utility Functions */
  doesMatch(firstItem: string, secondItem: string) {
    return StringHelper.doesFirstStringContainSecond(firstItem, secondItem);
  }
  formatSuggestions(suggestionList: any[]) {
    if (!suggestionList[0]) suggestionList[0] = { NoItemFound: true };
    let list = [{ header: 'Invoices' }, ...suggestionList];
    return list;
  }
  formatMatchedString(stringToChange: string) {
    if (!this.searchText) return stringToChange;
    let location = stringToChange
      .toLowerCase()
      .search(this.searchText.trim().toLowerCase());
    let stringStart = stringToChange.substring(0, location);
    let stringEnd = stringToChange.substring(
      location + this.searchText.trim().length,
      9999
    );
    let stringMatch = stringToChange.substring(
      location,
      location + this.searchText.trim().length
    );
    return `${stringStart}<span class="roboto-bold">${stringMatch}</span>${stringEnd}`;
  }
  clearSearch() {
    this.selectedSuggestion = null;
  }
  search() {
    if (this.selectedSuggestion) return;
    if (this.searchText) this.suggestions.push(this.searchText);
    this.selectedSuggestion = this.suggestions[this.suggestions.length - 1];
    if (!this.searchText || this.searchText.length < 3) {
      //   this.currentFilter = this.filterOptions[0];
      this.clearSearch();
    } else {
      //   this.refreshPagination();
    }
  }
  async getSuggestions() {
    this.isLoading = true;
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(async () => {
      try {
        let model = {
          Take: 10,
          Skip: 0,
          Query: !this.searchText ? this.searchText : this.searchText.trim(),
          FilterOptions: 0
        };
        // this.$store.dispatch('invoices/GetFilteredInvoices', model);
        const response = await InvoiceService.GetAutocomleteSuggestionsBySearchQuery(
          model
        );
        this.suggestions = [];
        this.suggestions = this.formatSuggestions(response.data);
      } catch (err) {
        console.log(err);
      }
      this.isLoading = false;
    }, this.doneTypingInterval);
  }
  /* Loaders */
  /* Mounted */
  /* Created */
  /* Emmited Functions */
}
